<template>
  <button
    class="block rounded-full shadow-md text-xs font-bold tracking-wide text-white mx-auto w-48 p-2 uppercase py-3"
    :class="{ 'bg-success' : success, 'bg-secondary': !success }"
    :disabled="disabled"
  >
    <font-awesome-icon
      v-if="loading"
      :icon="['fas', 'circle-notch']"
      spin
    />
    <template
      v-else
    >
      {{ label }}
    </template>
  </button>
</template>

<script>
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons/faCircleNotch';
import { library } from '@fortawesome/fontawesome-svg-core';

export default {
  name: 'Btn',

  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    label: {
      default: 'Button',
      type: String,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    success: {
      default: false,
      type: Boolean,
    },
  },

  created() {
    library.add(faCircleNotch);
  },
};
</script>
